// extracted by mini-css-extract-plugin
var _1 = "pE3VJla6zVXqmswjKN54";
export { _1 as "tagBadge" }
